import { render, staticRenderFns } from "./LogoPage.vue?vue&type=template&id=94a54a3c&scoped=true&"
import script from "./LogoPage.vue?vue&type=script&lang=js&"
export * from "./LogoPage.vue?vue&type=script&lang=js&"
import style0 from "./LogoPage.vue?vue&type=style&index=0&id=94a54a3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a54a3c",
  null
  
)

export default component.exports